import { BottomSheet, type UseModalState } from "@clipboard-health/ui-components";
import { DialogContent, Stack } from "@mui/material";
import { useCallback } from "react";

import { BottomSheetHeader } from "./BottomSheetHeader";
import { Button } from "./Button";
import { DialogFooter } from "./DialogFooter";

interface FileUploaderBottomSheetProps {
  modalState: UseModalState;
  onTakePhoto: () => Promise<void>;
  onSelectPhotoFromCameraRoll: () => Promise<void>;
  onSelectFile: () => Promise<void>;
}

export function FileUploaderBottomSheet(props: FileUploaderBottomSheetProps) {
  const { modalState, onTakePhoto, onSelectPhotoFromCameraRoll, onSelectFile } = props;

  const handleClose = useCallback(() => {
    modalState.closeModal();
  }, [modalState]);

  return (
    <BottomSheet
      footer={<DialogFooter orientation="vertical" />}
      header={<BottomSheetHeader onClose={handleClose} />}
      modalState={modalState}
    >
      <DialogContent sx={{ padding: 5, paddingBottom: 0 }}>
        <Stack spacing={3}>
          <Button variant="outlined" size="large" onClick={onTakePhoto}>
            Take a photo
          </Button>
          <Button variant="outlined" size="large" onClick={onSelectPhotoFromCameraRoll}>
            Upload from camera roll
          </Button>
          <Button variant="outlined" size="large" onClick={onSelectFile}>
            Upload from file manager
          </Button>
        </Stack>
      </DialogContent>
    </BottomSheet>
  );
}
